import { render, staticRenderFns } from "./leifeng-groupbuy-orderlist.vue?vue&type=template&id=67daf73e&scoped=true&"
import script from "./leifeng-groupbuy-orderlist.vue?vue&type=script&lang=js&"
export * from "./leifeng-groupbuy-orderlist.vue?vue&type=script&lang=js&"
import style0 from "./leifeng-groupbuy-orderlist.vue?vue&type=style&index=0&id=67daf73e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67daf73e",
  null
  
)

export default component.exports